import React, { useState, useEffect } from "react";
import "./App.css";
import Navbar from "./components/navbar.js";
import Preloader from "./components/preloader";
import { Switch, Route } from "react-router-dom";
import Homepage from "./components/homepage";
import Aboutpage from "./components/aboutpage";
import Pagenotfound from "./components/pagenotfound";
import Portfoliopage from "./components/portfoliopage";
import Contactpage from "./components/contactpage";
import { Cookie } from "./utils";

const App = (props) => {
  const [busy, setBusy] = useState(true);
  const [theme, setTheme] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => {
      setBusy(false);
    }, 0);
    setTheme(Cookie("theme") === "dark");
    return () => {
      clearTimeout(t);
      setBusy(true);
    };
  }, [props.location.pathname]);

  const handleThemeToggle = () => {
    Cookie("theme", !theme ? "dark" : "light", 365);
    setTheme(!theme);
  };

  return (
    <div className={`app ${theme ? "" : "light-theme"}`}>
      <Route
        render={(route) => (
          <Navbar {...route} theme={theme} toggleTheme={handleThemeToggle} />
        )}
      />
      <Switch>
        <Route path="/" exact component={Homepage} />
        <Route path="/about" component={Aboutpage} />
        <Route path="/portfolio" component={Portfoliopage} />
        <Route path="/contact" component={Contactpage} />
        <Route component={Pagenotfound} />
      </Switch>
      <button
        className="theme-toggle btn btn-primary d-lg-none"
        onClick={handleThemeToggle}
      >
        <span className="sr-only">{theme ? "dark" : "light"} theme</span>
      </button>
      <Preloader loading={busy} />
    </div>
  );
};

export default App;
